import styled from 'styled-components'
import { Avatar, AvatarProps } from 'antd'
import { UserOutlined } from '@ant-design/icons'

export const StyledAvatar = styled((props: AvatarProps) => {
  return <Avatar icon={<UserOutlined />} {...props} />
})<{}>``
